const translation = {
  cn: {
    account: {
      login: '登陆',
      logout: '注销',
      username: '用户名',
      password: '密码',
      remember: '记住我'
    },
    state: {
      t1: '任务',
      t2: '完成',
      t3: '总数'
    },
    task: {
      comment: {
        placeholder: '你有什么想法？',
        submit: '提交'
      },
      intent: {
        t1: '问题',
        t2: '意图'
      }
    }
  },
  en: {
  }
}

export default translation
